import { render, staticRenderFns } from "./TierComponent.vue?vue&type=template&id=1ae68d92&"
import script from "./TierComponent.vue?vue&type=script&lang=js&"
export * from "./TierComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports